<template>
  <div v-if="isOpen" class="auth-modal-overlay" @click.self="closeModal">
    <div class="auth-modal">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="closeModal">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>
      </button>

      <!-- 标签页切换 -->
      <div class="auth-tabs">
        <button 
          class="tab-btn" 
          :class="{ active: activeTab === 'login' }"
          @click="activeTab = 'login'"
        >
          登录
        </button>
        <button 
          class="tab-btn" 
          :class="{ active: activeTab === 'register' }"
          @click="activeTab = 'register'"
        >
          注册
        </button>
      </div>

      <!-- 登录表单 -->
      <form v-if="activeTab === 'login'" @submit.prevent="handleLogin" class="auth-form">
        <h2>用户登录</h2>
        
        <div class="form-group">
          <label for="login-account">账号/手机号/邮箱</label>
          <input 
            id="login-account"
            v-model="loginForm.account" 
            type="text" 
            placeholder="请输入账号、手机号或邮箱"
            @keyup.enter="handleLogin"
          />
        </div>

        <div class="form-group">
          <label for="login-password">密码</label>
          <input 
            id="login-password"
            v-model="loginForm.password" 
            type="password" 
            placeholder="请输入密码"
            @keyup.enter="handleLogin"
          />
        </div>

        <div v-if="loginError" class="error-message">
          {{ loginError }}
        </div>

        <button 
          type="submit" 
          class="submit-btn"
          :disabled="loginLoading"
        >
          {{ loginLoading ? '登录中...' : '登录' }}
        </button>
      </form>

      <!-- 注册表单 -->
      <form v-if="activeTab === 'register'" @submit.prevent="handleRegister" class="auth-form">
        <h2>用户注册</h2>
        
        <div class="form-group">
          <label for="register-username">用户名</label>
          <input 
            id="register-username"
            v-model="registerForm.username" 
            type="text" 
            placeholder="请输入用户名（3-20字符）"
            @keyup.enter="handleRegister"
          />
        </div>

        <div class="form-group">
          <label for="register-password">密码</label>
          <input 
            id="register-password"
            v-model="registerForm.password" 
            type="password" 
            placeholder="请输入密码（6-20字符）"
            @keyup.enter="handleRegister"
          />
        </div>

        <div class="form-group">
          <label for="register-confirm">确认密码</label>
          <input 
            id="register-confirm"
            v-model="registerForm.confirmPassword" 
            type="password" 
            placeholder="请再次输入密码"
            @keyup.enter="handleRegister"
          />
        </div>

        <div v-if="registerError" class="error-message">
          {{ registerError }}
        </div>

        <button 
          type="submit" 
          class="submit-btn"
          :disabled="registerLoading"
        >
          {{ registerLoading ? '注册中...' : '注册' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import { loginUser, registerUser } from '@/api/config';

export default {
  name: 'AuthModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 'login',
      loginForm: {
        account: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      loginLoading: false,
      registerLoading: false,
      loginError: '',
      registerError: ''
    };
  },
  methods: {
    async handleLogin() {
      this.loginError = '';

      if (!this.loginForm.account.trim()) {
        this.loginError = '请输入账号';
        return;
      }

      if (!this.loginForm.password.trim()) {
        this.loginError = '请输入密码';
        return;
      }

      this.loginLoading = true;

      try {
        const response = await loginUser(this.loginForm.account, this.loginForm.password);

        if (response.code === 1) {
          const userInfo = response.data.userinfo;
          localStorage.setItem('token', userInfo.token);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          
          this.$emit('login-success', userInfo);
          this.closeModal();
          
          ElMessage({
            message: '登录成功',
            type: 'success'
          });
        } else {
          this.loginError = response.msg || '登录失败';
        }
      } catch (error) {
        console.error('登录错误:', error);
        this.loginError = '登录失败，请稍后重试';
      } finally {
        this.loginLoading = false;
      }
    },

    async handleRegister() {
      this.registerError = '';

      if (!this.registerForm.username.trim()) {
        this.registerError = '请输入用户名';
        return;
      }

      if (this.registerForm.username.length < 3 || this.registerForm.username.length > 20) {
        this.registerError = '用户名长度应为3-20字符';
        return;
      }

      if (!this.registerForm.password.trim()) {
        this.registerError = '请输入密码';
        return;
      }

      if (this.registerForm.password.length < 6 || this.registerForm.password.length > 20) {
        this.registerError = '密码长度应为6-20字符';
        return;
      }

      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.registerError = '两次输入的密码不一致';
        return;
      }

      this.registerLoading = true;

      try {
        const response = await registerUser(this.registerForm.username, this.registerForm.password);

        if (response.code === 1) {
          const userInfo = response.data.userinfo;
          localStorage.setItem('token', userInfo.token);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          
          this.$emit('register-success', userInfo);
          this.closeModal();
          
          ElMessage({
            message: '注册成功',
            type: 'success'
          });
        } else {
          this.registerError = response.msg || '注册失败';
        }
      } catch (error) {
        console.error('注册错误:', error);
        this.registerError = '注册失败，请稍后重试';
      } finally {
        this.registerLoading = false;
      }
    },

    closeModal() {
      this.loginForm = { account: '', password: '' };
      this.registerForm = { username: '', password: '', confirmPassword: '' };
      this.loginError = '';
      this.registerError = '';
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.auth-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 420px;
  padding: 40px 30px;
  position: relative;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: #f0f0f0;
}

.close-btn svg {
  width: 20px;
  height: 20px;
  fill: #666;
}

.auth-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  border-bottom: 2px solid #f0f0f0;
}

.tab-btn {
  flex: 1;
  padding: 12px 0;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #999;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
}

.tab-btn.active {
  color: #007AFF;
}

.tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #007AFF;
}

.auth-form h2 {
  margin: 0 0 25px 0;
  font-size: 24px;
  color: #333;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #007AFF;
  box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.error-message {
  color: #f56c6c;
  font-size: 14px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #fef0f0;
  border-radius: 4px;
  border-left: 3px solid #f56c6c;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background-color: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  margin-top: 10px;
}

.submit-btn:hover:not(:disabled) {
  background-color: #0051d5;
  transform: translateY(-2px);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .auth-modal {
    width: 95%;
    padding: 30px 20px;
  }

  .auth-form h2 {
    font-size: 20px;
  }
}
</style>
